import React, { useState, useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import AndroidBottomNav from './AndroidBottomNav';

const AndroidLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    console.log('AndroidLayout mounted');
    console.log('Current location:', location.pathname);
  }, []);

  // Update active tab based on current route
  useEffect(() => {
    console.log('Location changed:', location.pathname);
    const path = location.pathname;
    if (path.includes('calendar')) setActiveTab(1);
    else if (path.includes('map')) setActiveTab(2);
    else if (path.includes('profile')) setActiveTab(3);
    else setActiveTab(0);
  }, [location]);

  const handleTabChange = (newValue) => {
    console.log('Tab changed to:', newValue);
    setActiveTab(newValue);
    switch (newValue) {
      case 0:
        navigate('/android');
        break;
      case 1:
        navigate('/android/calendar');
        break;
      case 2:
        navigate('/android/map');
        break;
      case 3:
        navigate('/android/profile');
        break;
      default:
        break;
    }
  };

  return (
    <Box 
      sx={{ 
        display: 'flex', 
        flexDirection: 'column',
        height: '100vh',
        width: '100%',
        overflow: 'hidden',
        backgroundColor: '#f5f5f5' // Add a background color to make sure the Box is visible
      }}
    >
      {/* Main content area */}
      <Box 
        sx={{
          flex: 1,
          overflow: 'auto',
          paddingBottom: '56px', // Space for bottom nav
          WebkitOverflowScrolling: 'touch', // Smooth scrolling on iOS
          backgroundColor: '#ffffff' // Add a background color to the content area
        }}
      >
        <Outlet />
      </Box>

      {/* Bottom navigation */}
      <AndroidBottomNav activeTab={activeTab} onTabChange={handleTabChange} />
    </Box>
  );
};

export default AndroidLayout; 